// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import handler from '../../handler';
import { errorComponents, errorMessages } from '../../api.constants';
import { generateSessionId } from '../../../utils/cookie.util';
import { API_CONFIG } from '../../config';

/**
 * This function submits errors to Raygun
 * @param {Object} errorArgs containing {errorMessage, errorObject, component, payload}
 */
const errorHandler = (errorArgs) => {
  const { errorMessage, errorObject, component, payload } = errorArgs;
  const { sessionCookieKey } = API_CONFIG;
  logger.error({
    error: errorMessage,
    errorTags: [component],
    extraData: {
      ...payload,
      errorComponent: component,
      errorObject,
      errorMessage,
      [sessionCookieKey]: generateSessionId(true),
    },
  });
};

/**
 * Abstractor layer for loading data from API for Layout
 */
const PromoCombinationAbstractor = {
  slotModuleMap: {},
  /**
   * This function loads data from graphQL service
   * @param {Object} params Object containing {page, brand, country, channel}
   */
  getPromoCombinationData: async ({ brand, country, channel, path, regionCode }, apiConfig) => {
    // return responseMock.data.promoCombination;
    logger.info(`Executing Promo Combination Query for ${path}: `);
    logger.debug(
      'Executing Promo Combination Query with params: ',
      `path:${path}`,
      `brand:${brand}`,
      `country:${country}`,
      `channel:${channel}`,
      `regionCode:${regionCode}`
    );
    return handler
      .fetchModuleDataFromGraphQL(
        {
          name: 'promoCombination',
          data: {
            path,
            brand,
            country,
            channel,
            regionCode,
          },
        },
        apiConfig,
        undefined
      )
      .then((response) => {
        let result;
        try {
          result = response.data.promoCombination;
          logger.info('Promo Combintion Query Executed Successfully');
          logger.debug('Promo Combination Query Result: ', JSON.stringify(result));
        } catch (error) {
          const { promoCombinationAbstractor } = errorComponents;
          const { promoCombinationError } = errorMessages;
          const errorObject = JSON.stringify(error);
          logger.debug(`${promoCombinationError} | Error Response: ${errorObject}`);
          errorHandler({
            errorMessage: promoCombinationError,
            errorObject,
            component: promoCombinationAbstractor,
            payload: response.data,
          });
          throw new Error(promoCombinationError);
        }

        return result;
      });
  },
};

export default PromoCombinationAbstractor;
